




























































































































import { computed, defineComponent, toRefs, unref } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';

import AppCard from '@berlin-front/common/components/elements/AppCard';
import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppInput from '@berlin-front/common/components/elements/AppInput';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppSeparator from '@berlin-front/common/components/elements/AppSeparator';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppMessageList from '@berlin-front/common/components/elements/AppMessageList';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import UserNameFooter from '@clusters/UserNameFooter';

import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { formatNumber, bemx } from '@berlin-front/common/utils';

import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { TEXT_ALIGNED } from '@berlin-front/common/components/elements/AppInput/composable';
import { TEXT_COLOR, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';
import { ALERT_TYPE } from '@berlin-front/common/components/atone-components/AtoneAlert/composable';
import { POINT_USE_TYPE } from '@/entity/pointUseType';
import { AMOUNT_DISPLAY_TYPE } from '@/entity/amountDisplayType';
import { ConfirmSettlementContext } from './composable';

export default defineComponent({
  name: 'ConfirmSettlementView',
  components: {
    AtoneAlert,
    AppButton,
    AppCard,
    AppContainer,
    AppInput,
    AppRow,
    AppSeparator,
    AppText,
    AppMessageList,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
    UserNameFooter,
  },

  setup() {
    const { useSettlement } = useContext(ConfirmSettlementContext);
    const {
      // 状態
      alert,
      state,
      pointUseType,
      amountDisplayType,

      // 表示項目
      retentionPoint,
      subtractPoint,
      itemTotalPrice,
      totalAmount,
      hasPoint,
      npcSystemHasError,
      memberName,
      onBlur,
      onInput,
      // action
      onSubmit,
    } = toRefs(useSettlement());

    const displayProps = computed(() => {
      const result = {
        /**
         * ポイント決済が適用されるタイミングについてのメッセージを表示するかどうか。
         * ポイントの利用が可能なユーザに対し、ポイント値引きが確定されるのは月末引き落とし時だということを示す。
         */
        showAlertMessageNpLoyaltyPointsApply: false,
        /**
         * 決済未確定であることを表示するかどうか。
         */
        showAlertMessageUnsettled: false,
        /**
         * 実際の価格の案内表示
         */
        showRealPriceInfoMessage: false,
        /**
         * 現在の支払いでNPポイントを利用するための方法を表示するかどうか。
         * 金額未確定かつ、ポイント支払い不可の状態で表示されるメッセージ。
         * 後でatoneアプリでポイント適用できる旨のメッセージ。
         */
        showAlertMessageToPayWithNpLoyaltyPoints: false,
        /**
         * 利用可能ポイント詳細。
         */
        availablePointDetail: 'この注文では、NPポイントを利用できません。',
        /**
         * ポイント入力欄を表示するかどうか。
         */
        showNpLoyaltyPointsInput: false,
        /**
         * 画面上の明細レコードに使用NPポイントの行を表示するかどうか。
         */
        showDetailRecordToPayWithNpLoyaltyPoints: false,
        /**
         * 商品合計表示
         */
        itemPrice: '---',
        /**
         * 合計金額表示テキスト
         */
        totalPrice: '---',
        /**
         * 合計金額表示単位
         */
        totalPriceUnit: '',
      };
      switch (unref(pointUseType)) {
        case POINT_USE_TYPE.ENABLED: {
          result.showAlertMessageNpLoyaltyPointsApply = true;
          result.showDetailRecordToPayWithNpLoyaltyPoints = true;
          result.showNpLoyaltyPointsInput = unref(hasPoint);
          if (unref(hasPoint)) {
            result.availablePointDetail = ((pt) => `保有NPポイント : ${pt}pt (${pt}円相当)`)(
              formatNumber(unref(retentionPoint)),
            );
          } else if (unref(npcSystemHasError)) {
            result.availablePointDetail = [
              `現在ポイントをご利用いただけません。`,
              `時間を空けて再度お試しください。`,
            ].join('\n');
          } else {
            result.availablePointDetail = '現在使用できるNPポイントはありません';
          }
          switch (unref(amountDisplayType)) {
            case AMOUNT_DISPLAY_TYPE.NORMAL: {
              result.itemPrice = `${formatNumber(unref(itemTotalPrice))}円`;
              result.totalPrice = formatNumber(unref(totalAmount));
              result.totalPriceUnit = '円';
              result.showAlertMessageUnsettled = false;
              result.showRealPriceInfoMessage = false;
              break;
            }
            case AMOUNT_DISPLAY_TYPE.UNSETTLED: {
              result.itemPrice = `${formatNumber(unref(itemTotalPrice))}円`;
              result.totalPrice = formatNumber(unref(totalAmount));
              result.totalPriceUnit = '円（未確定）';
              result.showAlertMessageUnsettled = true;
              result.showRealPriceInfoMessage = true;
              break;
            }
            case AMOUNT_DISPLAY_TYPE.HIDE: {
              result.itemPrice = '---';
              result.totalPrice = '---';
              result.totalPriceUnit = '円';
              result.showAlertMessageUnsettled = false;
              result.showRealPriceInfoMessage = true;
              break;
            }
            default:
          }
          break;
        }
        case POINT_USE_TYPE.DISABLED: {
          switch (unref(amountDisplayType)) {
            case AMOUNT_DISPLAY_TYPE.NORMAL: {
              result.itemPrice = `${formatNumber(unref(itemTotalPrice))}円`;
              result.totalPrice = formatNumber(unref(totalAmount));
              result.totalPriceUnit = '円';
              result.showAlertMessageUnsettled = false;
              result.showRealPriceInfoMessage = false;
              break;
            }
            case AMOUNT_DISPLAY_TYPE.UNSETTLED: {
              result.showAlertMessageToPayWithNpLoyaltyPoints = true;
              result.itemPrice = `${formatNumber(unref(itemTotalPrice))}円`;
              result.totalPrice = formatNumber(unref(totalAmount));
              result.totalPriceUnit = '円（未確定）';
              result.showAlertMessageUnsettled = true;
              result.showRealPriceInfoMessage = true;
              break;
            }
            case AMOUNT_DISPLAY_TYPE.HIDE: {
              result.showAlertMessageToPayWithNpLoyaltyPoints = true;
              result.itemPrice = '---';
              result.totalPrice = '---';
              result.totalPriceUnit = '円';
              result.showAlertMessageUnsettled = false;
              result.showRealPriceInfoMessage = true;
              break;
            }
            default:
          }
          break;
        }
        default:
      }
      return result;
    });
    const className = computed(() => bemx('ConfirmSettlementView', { hasPoint: unref(hasPoint) }));

    return {
      // 状態
      alert,
      state,
      // 表示項目
      itemTotalPrice,
      amountDisplayType,
      subtractPoint,
      memberName,
      onBlur,
      displayProps,

      // action
      onSubmit,
      onInput,

      // プレゼンテーションレイヤーの値。
      className,

      // 定数値。
      HEADER_TYPE,
      TEXT_ALIGNED,
      ALERT_TYPE,
      HEIGHT_TYPE,
      TEXT_SIZE,
      TEXT_COLOR,
      TEXT_WEIGHT,

      // 関数。
      formatNumber,
    };
  },
});
